import LinearProgress, {linearProgressClasses} from '@mui/material/LinearProgress';
import {styled} from '@mui/material/styles';
import {shouldForwardProp} from '@mui/system';

const CustomizedLinearProgress = styled(LinearProgress, {
  shouldForwardProp: prop => prop !== 'filledColor' && prop !== 'emptyColor' && prop !== 'stylesOverrides'
})(({theme, filledColor, emptyColor, stylesOverrides}) => ({
  width: '100%',
  height: 4,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: emptyColor
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: filledColor || theme.palette.secondary.main
  },
  ...stylesOverrides
}));

export default CustomizedLinearProgress;
